import { render, staticRenderFns } from "./resume-recommendations-view.vue?vue&type=template&id=16caf3e0&scoped=true&"
import script from "./resume-recommendations-view.vue?vue&type=script&lang=js&"
export * from "./resume-recommendations-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16caf3e0",
  null
  
)

export default component.exports